<template>
  <Dialog
    :visible="visible"
    modal
    :draggable="false"
    dismissable-mask
    :style="{ width: '28rem' }"
    :breakpoints="{ '575px': '92vw' }"
    :pt="{ root: { 'data-testid': 'qc-confirm' } }"
    @update:visible="value => { if (!value) emit('cancel') }"
  >
    <template #header>
      <div class="flex items-center gap-2.5">
        <span class="pi pi-exclamation-triangle text-lg text-amber-500" aria-hidden="true"></span>
        <h3 class="text-lg font-semibold text-gray-800">
          {{ $t('messages.evaluation.qualityCheck.confirm.title') }}
        </h3>
      </div>
    </template>

    <div class="text-sm leading-relaxed text-gray-700">
      <i18n-t keypath="messages.evaluation.qualityCheck.confirm.cost" tag="p" scope="global" class="mb-2">
        <template #amount>
          <strong class="font-semibold text-gray-800">{{ $t('messages.evaluation.qualityCheck.confirm.costAmount') }}</strong>
        </template>
      </i18n-t>
      <p>{{ $t('messages.evaluation.qualityCheck.confirm.sure') }}</p>
      <div
        v-if="fileName"
        class="mt-3 flex items-center gap-2 break-words rounded-md border border-gray-200 bg-gray-50 px-3 py-2 text-xs text-gray-500"
        data-testid="qc-confirm-file"
      >
        <span class="pi pi-file" aria-hidden="true"></span>
        <span class="min-w-0">{{ fileName }}</span>
      </div>
    </div>

    <template #footer>
      <Button
        :label="$t('messages.evaluation.qualityCheck.confirm.cancel')"
        severity="secondary"
        class="w-auto!"
        data-testid="qc-confirm-cancel"
        @click="emit('cancel')"
      />
      <Button
        :label="$t('messages.evaluation.qualityCheck.confirm.start')"
        icon="pi pi-shield"
        autofocus
        class="w-auto!"
        data-testid="qc-confirm-start"
        @click="emit('confirm')"
      />
    </template>
  </Dialog>
</template>

<script setup>
/**
 * RED-351 rework — `Kvaliteedikontroll on tasuline`, prototype v3's cost gate.
 *
 * A live read no longer counts down into a paid run: it opens this dialog, and
 * so does every other way to start a check. Nothing starts without the explicit
 * `Käivita kontroll`; `Katkesta`, Esc and a click outside all mean "no". The
 * file name is repeated so a wrong file (a contract, last year's draft) is
 * caught before the money is spent — RED-344 caps what one report may cost.
 */
defineProps({
  visible: { type: Boolean, default: false },
  fileName: { type: String, default: '' },
})

const emit = defineEmits(['confirm', 'cancel'])
</script>
